(function () {
  function updateSelectedImage(addon) {
    var selectedVariant = addon.querySelector('[data-cosmetic-bag-addon-variant]:checked');
    if (!selectedVariant) return;

    addon.querySelectorAll('[data-cosmetic-bag-addon-image]').forEach(function (image) {
      image.hidden = image.dataset.cosmeticBagAddonImage !== selectedVariant.value;
    });
  }

  function initialiseAddon(addon) {
    if (addon.dataset.initialised === 'true') return;

    var toggle = addon.querySelector('[data-cosmetic-bag-addon-toggle]');
    var options = addon.querySelector('[data-cosmetic-bag-addon-options]');

    if (!toggle || !options) return;

    addon.dataset.initialised = 'true';
    toggle.checked = false;
    options.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');

    var productForm = toggle.closest('form');
    if (productForm) {
      productForm.classList.remove('cosmetic-bag-addon-selected');
    }

    updateSelectedImage(addon);

    toggle.addEventListener('change', function () {
      options.hidden = !toggle.checked;
      toggle.setAttribute('aria-expanded', toggle.checked ? 'true' : 'false');

      var productForm = toggle.closest('form');
      if (productForm) {
        productForm.classList.toggle('cosmetic-bag-addon-selected', toggle.checked);
      }
    });

    addon.querySelectorAll('[data-cosmetic-bag-addon-variant]').forEach(function (variant) {
      variant.addEventListener('change', function () {
        updateSelectedImage(addon);
      });
    });
  }

  function initialiseAddons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cosmetic-bag-addon]').forEach(initialiseAddon);
  }

  function prepareCartAdd(form) {
    var toggle = form.querySelector('[data-cosmetic-bag-addon-toggle]');

    if (!toggle || !toggle.checked) return null;

    var selectedVariant = form.querySelector('[data-cosmetic-bag-addon-variant]:checked:not(:disabled)');

    if (!selectedVariant) return null;

    var formData = new FormData(form);
    var properties = {};

    formData.forEach(function (value, key) {
      var propertyMatch = key.match(/^properties\[(.+)\]$/);

      if (propertyMatch && value !== '') {
        properties[propertyMatch[1]] = value;
      }
    });

    var mainItem = {
      id: Number(formData.get('id')),
      quantity: Number(formData.get('quantity') || 1)
    };

    if (Object.keys(properties).length) {
      mainItem.properties = properties;
    }

    if (formData.get('selling_plan')) {
      mainItem.selling_plan = Number(formData.get('selling_plan'));
    }

    return {
      items: [
        mainItem,
        {
          id: Number(selectedVariant.value),
          quantity: 1
        }
      ]
    };
  }

  function showError(form, message) {
    var existingWarning = form.parentNode.querySelector('.cosmetic-bag-addon-warning');
    if (existingWarning) existingWarning.remove();

    var warning = document.createElement('p');
    warning.className = 'warning cosmetic-bag-addon-warning';
    warning.textContent = message;
    form.insertAdjacentElement('afterend', warning);
  }

  async function submitWithAddon(event, button, form) {
    var request = prepareCartAdd(form);
    if (!request) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var buttonText = button.querySelector('.text');
    var originalText = buttonText ? buttonText.textContent : '';

    button.disabled = true;
    button.classList.add('disabled');

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || 'The items could not be added to your cart.');
      }

      if (buttonText) buttonText.textContent = 'Added!';

      if (typeof window.monster_refresh === 'function') {
        await window.monster_refresh(true);
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      showError(form, error.message || 'The items could not be added to your cart. Please try again.');
    } finally {
      window.setTimeout(function () {
        button.disabled = false;
        button.classList.remove('disabled');
        if (buttonText) buttonText.textContent = originalText;
      }, 800);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialiseAddons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAddons(event.target);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.ajax-submit, .add_to_cart');
    if (!button) return;

    var form = button.closest('form');
    if (!form || !form.querySelector('[data-cosmetic-bag-addon-toggle]:checked')) return;

    submitWithAddon(event, button, form);
  }, true);

  window.ClemenceCosmeticBagAddon = {
    prepareCartAdd: prepareCartAdd
  };
})();
